import React from "react";
import { withRouter } from "react-router-dom";
import { isAuthenticated } from "../store/selectors/AuthSelectors";
import { connect } from "react-redux";
import { QueryClientProvider, QueryClient } from "react-query";
import Header from "../Header/Header";
import TransferMain from "./TransferMain";

const queryClient = new QueryClient();

const dashboardstyles = {
  gradientBg: "bg-gradient-to-b from-[#000000]  to-[#000000] min-h-screen pb-[5rem]",
};

const TransferLayout = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Header />
      <div className={`${dashboardstyles.gradientBg}`}>
        <div className="w-full">
          <TransferMain />
        </div>
      </div>
    </QueryClientProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(TransferLayout));
